import ko from '@tko/build.knockout';
import $ from 'jquery';
import FormatterCommon from './formatter-common';
import _ from 'lodash';
    
    

    function KPICellFormatter(params, observableOptions, dataSources, panelId) {
        var self = this;

        self.panelId = panelId;
        self.observableOptions = observableOptions;
        self.dataSources = dataSources;

        self.sourcetype = _.get(params, 'type', '');

        self.datapresorted = _.get(params, 'datapresorted', false);
        self.dataprepaged = _.get(params, 'dataprepaged', false);

        self.observableParams = dataSources[0].observableParams;
        self.observableFormattedData = ko.observable();

        self.subscriptions = [];
    }

    function ComposeData(metadata, sourcelist, options, initFlag) {
        var result = sourcelist;

        result.metadata = metadata;

        return result;
    }

    KPICellFormatter.prototype.RefreshData = function () {
        var self = this;

        if (self.observableParams && !_.isEmpty(self.observableParams())) {
            self.sourceList = self.dataRepository
                .getDictionaryValue(self.dataRepository.FlexQueryResultDictionary, self.observableParams());
        }

        if (!self.sourceList) {
            return self.observableFormattedData({ metadata: self.metadata, rows: [] });
        }

        self.observableFormattedData(ComposeData(
            self.metadata,
            self.sourceList,
            self.observableOptions())
        );
    };

    KPICellFormatter.prototype.LoadFromCache = function (params, context) {
        var self = context;

        var sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.FlexQueryResultDictionary, params);

        if (!sourceList) {
            return false;
        }

        self.observableFormattedData(ComposeData(self.metadata,
            sourceList,
            self.observableOptions(),
            null));

        return true;
    };

    KPICellFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    KPICellFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    KPICellFormatter.prototype.initialize = function (dataRepository, dataProvider) {
        var self = this;

        self.dataRepository = dataRepository;
        self.dataProvider = dataProvider;
        self.metadata = self.dataRepository.flexQueryMetaData();
        
        self.subscriptions.push(self.dataRepository.FlexQueryResultDictionary.subscribe(function (newval) {
            var myparams = ko.toJSON(self.observableParams());
            if (self.dataRepository.lastPanelId === self.panelId) {
                self.DataUpdated();
            }
        }));

        self.subscriptions.push(self.dataRepository.flexQueryMetaData.subscribe(function (newval) {
            self.metadata = self.dataRepository.flexQueryMetaData();
            self.observableFormattedData({ metadata: self.metadata, rows: [] });
        }));

        self.RefreshData();
    };

    KPICellFormatter.prototype.getObservableData = function () {
        var self = this;

        return self.observableFormattedData;
    };

    KPICellFormatter.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default KPICellFormatter;
